/**
 * Live Assist protocol (PLAN §14). Co-browse rides the recording stream; the
 * messages below travel over the SDK's WebSocket (`/v1/live`) for signaling,
 * consent, annotations, and control, and over LiveKit for audio.
 *
 *   SDK  -> WS  /v1/live?key=&session=      (upgrade from the recording connection or a second socket)
 *   Agent -> WS /v1/live/agent?session=     (authenticated, requires role support|admin|owner)
 *   Server relays AgentToUser / UserToAgent messages and enforces the consent ladder server-side too.
 */
export const CONTROL_POLICY = {
    userPriorityResumeMs: 2000,
    blockedInputTypes: ["password"],
    blockedAutocomplete: ["cc-number", "cc-csc", "cc-exp", "one-time-code"],
    blockedSelectors: ["[data-backstory-mask]", "[data-backstory-block]"],
    notSynthesizable: ["file_picker", "clipboard", "fullscreen", "autofill", "beforeunload"],
};
export const CONSENT_WORDING = {
    cobrowse: "Annotations and remote control.",
    voice: "Wants to start an audio-only call.",
    annotate: "{agent} from {org} would like to highlight and draw on this page. Drawings disappear after 10 seconds. They cannot click or type.",
    control: "Allow {agent} from {org} to click and type on this page for you? You can stop access at any time.",
    record: "Record this support session (screen view, drawings, and audio) for quality and training?",
};
//# sourceMappingURL=live.js.map